var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column ma-10 data-board-box"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"d-flex py-15 mr-auto title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("rightTopBox")],2),_c('div',{staticClass:"col"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }